import React from 'react'

import './styles.scss'
import EditIcon from 'components/icons/EditIcon'
import IconButton from 'components/forms/IconButton'

/**
 * Input text
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.htmlFor]
 * @param {string} [props.title]
 * @param {boolean} [props.displayEdit]
 * @param {function} [props.onClickEdit]
 * @param {React.Component} [props.actionButtons]
 *
 * @returns {React.Component}
 */
const InputLabel = (props) => {
  const {
    className = '', htmlFor = null, title = '', displayEdit = false, onClickEdit,
    actionButtons
  } = props

  if (!title) return null

  return (
    <div className={`nx-input-label ${className}`}>
      <label
        className="nx-input-label__title"
        htmlFor={htmlFor}
      >
        {title}
      </label>
      {
        displayEdit
          ? (
            <div className="nx-input-label__action-btns">
              <IconButton
                onClick={onClickEdit ? () => onClickEdit() : null}
                fontSize='16px'
                className='action-btn-icons'
              >
                <EditIcon size='inherit' />
              </IconButton>
            </div>
          )
          : null
      }
      {
        actionButtons
          ? actionButtons
          : null
      }
    </div>
  )
}

export default InputLabel
